module.exports = __webpack_public_path__ + "img/skincare.8ecbbdcb.svg";